// extracted by mini-css-extract-plugin
export default {"text":"TextSection_text__VN5Wo","center":"TextSection_center__APG1c"};